export enum OnboardingStatus {
    VERIFIED = 1,
    RC_REVIEW = 2,
    UPLOAD_DOCUMENT = 3,
    DOCUMENTS_REVIEW = 4,
    DOCUMENTS_REJECTED = 5,
    RC_REJECTED = 6,
}

export interface OnboardingDocument {
    authorized: number;
    documentId: number;
    documentName: string;
    documentUrl: string;
    itemId: number;
    rejectedMessage: string;
    status: number;
    uploaded: boolean;
}
